const Keystore = require('./src/keystore')
module.exports = Keystore()
